// extracted by mini-css-extract-plugin
export default {"inputbox_container":"style_inputbox_container__91SVH","inpuxbox":"style_inpuxbox__+iAPd","inputbox_icon":"style_inputbox_icon__+xUUw"};